export enum CardDetailsIds {
  CardNumber = 'card-details-form__card-number',
  ValidUntil = 'card-details-form__valid-until',
  CVC = 'card-details-form__cvc',
  NameOnCard = 'card-details-form__name-on-card',
  PostCode = 'card-details-form__post-code',
  Country = 'card-details-form__country'
}
